import React, { Component } from 'react'
import { reduxForm, formValueSelector, change } from 'redux-form'
import { connect } from 'react-redux'
import moment from 'moment'
import * as _ from 'lodash'
import Loader from 'react-loader'
import SelectField from '../../shared/SelectField'
import { transformFaculties, transformYears, transformEducationYear, MONTHS as months } from '../../../utils/const'
import { getCurrentYear } from '../../../utils/getItemFromRange'
import NoData from '../../../assets/NoData/NoData'
import styles from './Schedule.module.css'
import GetHeader from '../helper/getHeader/GetHeader';

import back1 from '../../../assets/dashboard/background_1.png'
import Search from '../personalDashbord/search/Search'
import BtnBack from '../helper/btnBackMTO/BtnBack'

const selector = formValueSelector('scheduleMTO')

class ScheduleMTO extends Component {
  state = {
    isLoaded: false,
    teacher: '',
    uni: false,
  }
  componentDidMount() {
    const { fetchYears, fetchEducationYear, fetchFaculty, fetchLkData, getUniversity, university, match } = this.props
    const { id } = match.params
    getUniversity()
    fetchYears()
    fetchEducationYear()
    window.scrollTo(0, 0)
    this.setInitialValues()
    this.setState({ uni: true })

  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.isLoaded && nextProps.yearsList.length && nextProps.educationYear.length && !_.isEmpty(nextProps.lkData)) {
      this.setState({ isLoaded: true })
    }
    // if (!_.isEqual(nextProps.myValues.year, this.props.myValues.year) && this.props.myValues.year) {
    //   const course = nextProps.lkData.yeducationyearid
    //   const yearNow = moment(getCurrentYear(this.props.yearsList).begdate).year()
    //   const yearCurrent = moment(this.props.yearsList.find(it => it.xp_key==nextProps.myValues.year).begdate).year()
    //   const newCourse = course - (yearNow - yearCurrent)>=1 ? course - (yearNow - yearCurrent) : course
    //   this.props.change("educationYear", newCourse)
    // }
  }

  componentDidUpdate(prevProps, prevState) {
    const { fetchFaculty, university } = this.props

    if (!prevState.isLoaded && this.state.isLoaded) {
      this.setInitialValues()
    }
    if (!prevProps.facultyList.length && this.props.facultyList.length) {
      this.setInitialValues()
    }
    if (!prevState.uni !== this.state.uni) {
      const { id } = this.props.match.params
      const urlPrefixMTO = (university.find((el, i) => i == id))?.api_url
      fetchFaculty(urlPrefixMTO)
    }
  }

  componentWillUnmount() {
    this.props.setInitialScehedule()
  }

  setInitialValues = () => {
    const { initialize, lkData, isTeacher, yearsList, facultyList, university, educationYear: educationYearList } = this.props
    const currentYear = getCurrentYear(yearsList)
    const faculty = !isTeacher && lkData.facultyid ? lkData.facultyid : (facultyList.length ? facultyList[0].idfaculty : null)
    const year = currentYear?.xp_key || yearsList[yearsList.length - 1]?.xp_key
    // Используем eyid из lkData или первый eyid из списка, или 0 (Все)
    const educationYear = lkData.yeducationyearid ? lkData.yeducationyearid : (educationYearList.length ? educationYearList[0].eyid : 0)
    const month = moment().month() + 1

    const { id } = this.props.match.params
    const urlPrefixMTO = (university.find((el, i) => i == id))?.api_url

    initialize({
      faculty,
      educationYear,
      year,
      month,
      urlPrefixMTO
    })
  }

  fetchSchedule = () => {
    const { myValues, fetchSchedule, schedule, university } = this.props
    const { faculty, educationYear, year, month, urlPrefixMTO } = myValues;
    (faculty && educationYear && year && month) && fetchSchedule(faculty, educationYear, year, month, urlPrefixMTO)
    //проверочные запросы
    //  fetchSchedule(3,3,32,11) //ПЕНЗА
    // fetchSchedule(0,1,34,11) //ПЕНЗА
    // fetchSchedule(0,3,32,7) //ПЕНЗА
    // fetchSchedule(0,2,32,7) ПЕНЗА
    // fetchSchedule(0,2,39,5) // СТАДИУМ СЛУЧАЙ С КРАЙНИМ ПУСТЫМ

  }

  checkDupl = (el, i, groups2) => {

    return (!!el[0]?.teachers && el[0]?.teachers === groups2[i - 1]?.[0]?.teachers) &&
      (!!el[0]?.rooms && el[0]?.rooms === groups2[i - 1]?.[0]?.rooms) &&
      (!!el[0]?.lessontype_name && el[0]?.lessontype_name === groups2[i - 1]?.[0]?.lessontype_name) &&
      (!!el[0]?.course_title && el[0]?.course_title === groups2[i - 1]?.[0]?.course_title)
  }

  renderSchedule(schedule) {

    const groups = this.props.groups.sort()

    const rows = []
    _.forOwn(schedule, day =>
      _.forOwn(day, (lessons, lecture,) => {
        const keys = Object.keys(day)
        const lessonsWithoutKR = lessons.filter(el => el[0].course_title !== null) // контр-е работы не имеют teachers:null, course_title:null из-за этого создают доп клетку
        const groups11 = groups.map((eel, i) => lessonsWithoutKR.find(el => el[0].groupname === eel) || []) // список наполненный отсутствующими уроками
        const groups2 = groups11.map((el, i) => el?.length && [{ ...el?.[0], index: i }] || [{ ...[0], index: i }])

        const duplicateLessonIndex = groups2.map((el, i) =>
          el.length && this.checkDupl(el, i, groups2)
            ? groups2.indexOf(el) : el) // список с индексами повторяющихся уроков

        const lessonsWithoutRepeat = groups2.filter((ele, i) => i !== duplicateLessonIndex.find(el => el !== 0 && el === i)) // список без повторяющихся уроков

        const row = (
          <tr>

            {/* день */}
            {lecture === keys[0] && (
              <td className={styles.leftHead} rowSpan={keys.length} style={{ width: '70px', backgroundColor: '#5a949f', color: 'white' }}>
                {moment(lessons[0][0].lessondate).format("DD  MMM")}
                <br />
                {moment(lessons[0][0].lessondate).format("ddd")}
              </td>
            )}
            {/* уроки и время */}
            <td className={styles.leftHead2}>
              {lessons[0][0].period_name}
              <br />
              {/* ({lessons[0][0].period_time}) */}
              ({(lessons[0][0].period_time).split(' ').join('')})
            </td>
            {/*курс и группа  */}
            {lessonsWithoutRepeat.map((lesson, indexLes) => {

              const colSpan = lessonsWithoutRepeat[indexLes + 1] !== undefined ? lessonsWithoutRepeat[indexLes + 1]?.[0]?.index - lesson[0]?.index : groups2.length - lesson[0]?.index

              return (
                lesson[0]?.teachers?.length
                  // && typeof(lesson) !== "number" 
                  ?

                  <td
                    key={indexLes}
                    className={styles.tg_s6z2}
                    colSpan={colSpan}
                    style={{ minWidth: '200px', color: 'black', }}
                  >
                    {lesson[0].course_title} <br />
                    {lesson[0].lessontype_name},({lesson[0].subject_title}/{lesson[0].tema_num}) <br />
                    {lesson[0].rooms} <br />
                    {lesson[0].teachers}
                  </td>
                  :
                  <td >
                  </td>
              )
            })

            }
          </tr>
        )
        rows.push(row)
      })
    )
    return rows
  }

  renderGroup = (group, index) => (

    <th key={index} className={styles.tdtg} style={{ backgroundColor: '#5a949f' }}>
      {group} группа
    </th>
  )

  render() {
    const { isLoading, facultyList, yearsList, educationYear, edyId, schedule, myValues } = this.props
    const { urlPrefixMTO } = myValues;
    const groups = this.props.groups ? this.props.groups.sort() : []
    const faculties = facultyList ? transformFaculties(facultyList) : []
    const years = transformYears(yearsList)
    const edYear = transformEducationYear(educationYear)
    const chosenEdYear = edYear.find(element => element.value === Number(edyId)) || '1 курс'
    const header = 'Расписание занятий'

    return (
      <div>
        <div
          style={{ height: '100vh', backgroundImage: "url('dashboard/background_1.png')" }}
          className={styles.wrapper}>

          <GetHeader title={<> РАСПИСАНИЕ ЗАНЯТИЙ </>} pathLogo={urlPrefixMTO} />
          <img src={back1} className={styles.bg} />

          <div className={styles.popupWrapper}>
            <div className={styles.popup}>
              <div className={styles.selectBlockWrapper}>

                <div className={styles.selectBlockOuter}>
                  <div className={styles.selectBlock}>
                    <div className={styles.inputWrapper}>
                      {/* <div className='usp__inputs footer__float_left' style={{ margin: '0px 15px' }}> */}
                      <SelectField labelStyling className={styles.selectField} name='faculty' label='Факультет ' options={
                        [{ name: 'Все', value: '0' },
                        ...faculties]
                      } />
                    </div>

                    <div className={styles.inputWrapper}>
                      <div >
                        <SelectField labelStyling className={styles.selectField} name='educationYear' options={[{ name: 'Все', value: 0 }, ...edYear]} label='Курс (рота) ' />
                      </div>
                    </div>

                    <div className={styles.inputWrapper}>
                      <div >
                        <SelectField labelStyling className={styles.selectField} name='year' options={years} label='Учебный год ' />
                      </div>
                    </div>

                    <div className={styles.inputWrapper}>
                      <div >
                        <SelectField labelStyling className={styles.selectField} name='month' options={months} label='Месяц' />
                      </div>
                    </div>
                    <div>
                    </div>
                  </div>
                </div>
                <div>
                  <button className={styles.button} onClick={this.fetchSchedule}>
                    Обновить
                  </button>
                </div>
              </div>
            </div>
          </div>


          {isLoading ? <Loader loaded={!isLoading} color='#5a949f' width={50} /> : schedule && (
            !_.isEmpty(schedule) ?
              <div className={styles.schedule__scroll}>
                <table className={styles.schedule}>
                  <thead className={styles.headRow}>
                    <tr>
                      <th className={styles.tg_s6z2} rowSpan='2'>
                        Дата
                      </th>
                      <th className={styles.tg_s6z2} rowSpan='2'>
                        Часы занятий
                      </th>
                      <th className='tg-70w9' style={{ color: 'black' }} colSpan={this.props.groups.length}>
                        {chosenEdYear.name}
                      </th>
                    </tr>
                    <tr>{groups.map(this.renderGroup)}</tr>
                  </thead>
                  <tbody>{this.renderSchedule(schedule)}</tbody>
                </table>
              </div> : <NoData text='данные отсутствуют' style={{ color: '#e71313' }} />
          )}

        </div>
        <BtnBack />
      </div>

    )
  }
}

const scheduleFormMTO = reduxForm({
  form: 'scheduleMTO',
})(ScheduleMTO)

export default connect(state => ({
  myValues: selector(state, 'faculty', 'educationYear', 'year', 'month', 'urlPrefixMTO'),
}), { change })(scheduleFormMTO)